import { ExpressionSpecification, SourceSpecification } from 'maplibre-gl'

const HILLSHADE: SourceSpecification = {
    type: 'raster-dem',
    tiles: ['/map-hillshade/{z}-{x}-{y}.webp'],
    minzoom: 0,
    maxzoom: 11,
    tileSize: 512,
    // tiles: ['https://vtc-cdn.maptoolkit.net/terrainrgb/{z}/{x}/{y}.webp'],
    // minzoom: 5,
    // maxzoom: 15,
    // tileSize: 256,
}

export const SOURCES: { [k: string]: SourceSpecification } = {
    hillshade: HILLSHADE,
    hillshade_terrain: HILLSHADE,
    'natural-earth': {
        type: 'vector',
        url: '/base-map/natural-earth',
    },
    'natural-earth-raster': {
        type: 'raster',
        url: '/base-map/natural-earth-raster',
    },
    iran: { type: 'vector', url: '/base-map/iran-old' },
    gooje: {
        type: 'vector',
        url: '/gooje-tilejson/',
    },
}

export const CATEGORY_MAP = [
    'match',

    ['get', 'domain'],

    'cafe',
    'domain/cafe',

    'teahouse',
    'domain/teahouse',

    'bakery',
    'domain/pastry',

    'restaurant',
    'domain/restaurant',

    'seafood',
    'domain/sea',

    'dizi',
    'domain/dizi',

    'ash',
    'domain/ash',

    'kababi',
    'domain/kebab',

    'kalle_pache',
    'domain/pache',

    'liver',
    'domain/liver',

    'ice_cream',
    'domain/icecream',

    'hot_dog',
    'domain/hotdog',

    'sandwich',
    'domain/sandwich',

    'falafel',
    'domain/falafel',

    'fried',
    'domain/fried',

    'dessert',
    'default',

    'juicery',
    'domain/juicery',

    'gelato',
    'domain/gelato',

    'none',
    [
        'match',
        ['get', 'group'],

        1,
        'domain/cafe',

        2,
        'domain/restaurant',

        3,
        'domain/fastfood',

        4,
        'domain/icecream',

        'default',
    ],

    'default',
] as ExpressionSpecification

export const DECOR_MAP = [
    'match',

    ['get', 'decor'],

    0,
    '',

    1,
    'decor/bookish',

    2,
    'decor/cultural',

    3,
    'theme-traditional',

    4,
    'theme-fantasy',

    5,
    'theme-musical',

    6,
    'theme-nature',

    7,
    'theme-games',

    8,
    'decor/minimal',

    9,
    'decor/modern',

    10,
    'theme-luxury',

    11,
    'theme-streetfood',

    'default',
] as ExpressionSpecification

export const AUDIENCE_MAP = [
    'match',

    ['get', 'audience'],

    0,
    '',

    1,
    'audience/family',

    2,
    'audience/friends',

    3,
    'audience/couple',

    4,
    'audience/business',

    'default',
] as ExpressionSpecification

export const CATEGORY_MAP_DOT = [
    'match',

    ['get', 'group'],

    1,
    'cafe-dot',

    2,
    'restaurant-dot',

    3,
    'fastfood-dot',

    4,
    'icecream-dot',

    'default-dot',
] as ExpressionSpecification

export const EVENT_MAP = [
    'match',

    ['get', 'eevent'],

    0,
    '',

    1,
    'halloween',

    'default',
] as ExpressionSpecification

// export const CATEGORY_MAP_HOVER = [
//     'match',
//     ['get', 'category'],
//     1,
//     'cafe-hover',
//     2,
//     'cafe-hover',
//     3,
//     'cafe-hover',
//     4,
//     'cafe-hover',
//     5,
//     'cafe-hover',
//     6,
//     'cafe-hover',
//     7,
//     'cafe-hover',
//     8,
//     'cafe-hover',
//     9,
//     'cafe-hover',
//     10,
//     'cafe-hover',
//     11,
//     'cafe-hover',
//     'cafe-hover',
// ]
